import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Add request interceptor to attach Auth0 access token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('LOCELLE:token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;